export const FERTILIZER_PRODUCTS_SET = 'FERTILIZER_PRODUCTS_SET';
export const FERTILIZER_PRODUCT_SET = 'FERTILIZER_PRODUCT_SET';

export const FERTILIZER_PRODUCT_CREATE_REQUESTED =
    'FERTILIZER_PRODUCT_CREATE_REQUESTED';
export const FERTILIZER_PRODUCT_CREATE_SUCCEEDED =
    'FERTILIZER_PRODUCT_CREATE_SUCCEEDED';
export const FERTILIZER_PRODUCT_CREATE_FAILED =
    'FERTILIZER_PRODUCT_CREATE_FAILED';

export const FERTILIZER_PRODUCT_UPDATE_REQUESTED =
    'FERTILIZER_PRODUCT_UPDATE_REQUESTED';
export const FERTILIZER_PRODUCT_UPDATE_SUCCEEDED =
    'FERTILIZER_PRODUCT_UPDATE_SUCCEEDED';
export const FERTILIZER_PRODUCT_UPDATE_FAILED =
    'FERTILIZER_PRODUCT_UPDATE_FAILED';

export const FERTILIZER_PRODUCT_DELETE_REQUESTED =
    'FERTILIZER_PRODUCT_DELETE_REQUESTED';
export const FERTILIZER_PRODUCT_DELETE_SUCCEEDED =
    'FERTILIZER_PRODUCT_DELETE_SUCCEEDED';
export const FERTILIZER_PRODUCT_DELETE_FAILED =
    'FERTILIZER_PRODUCT_DELETE_FAILED';

export const FERTILIZER_PRODUCT_CREATE_NAMESPACE = 'FERTILIZER_PRODUCT_CREATE';
export const FERTILIZER_PRODUCT_UPDATE_NAMESPACE = 'FERTILIZER_PRODUCT_UPDATE';
export const FERTILIZER_PRODUCT_DELETE_NAMESPACE = 'FERTILIZER_PRODUCT_DELETE';
